module.exports = __webpack_public_path__ + "img/invoice-de-female-sl.468179c5.png";